<template>
  <div v-if="loaditem" class="details">
    <el-form :label-position="'right'" label-width="120px" :model="queryname">
      <el-form-item label="标题">
        <el-input v-model="query.title" style="width: 200px;" placeholder="请输入内容" />
      </el-form-item>
      <el-form-item label="公众号">
        <el-autocomplete
          v-model="queryname.app_name"
          style="width:200px"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入公众号"
          @select="handleSelect"
        />
      </el-form-item>
      <el-form-item label="广告主">
        <!-- 选了广告主才可以选数据源 -->
        <el-autocomplete
          v-model="queryname.account_name"
          style="width:200px"
          :fetch-suggestions="querySearchAsyncad"
          placeholder="请输入广告主"
          @select="handleSelectad"
        />
      </el-form-item>
      <el-form-item label="数据源">
        <el-autocomplete
          v-model="queryname.action_name"
          style="width:200px"
          :fetch-suggestions="querySearchAsyncuser"
          placeholder="选广告主才可以选数据源"
          :disabled="queryname.account_name===null"
          @select="handleSelectuser"
        />
      </el-form-item>
      <el-form-item label="链接识别码">
        <el-input v-model="query.link_code" style="width: 200px;" placeholder="请输入6位识别码" />
        <el-button type="primary" size="mini" style="margin-left:10px;" @click="generateRandomString">随机生成</el-button>
      </el-form-item>
      <el-form-item label="内容" class="box" style="width: 500px;">
        <el-button style="float: right;margin-bottom: 5px;" type="success" icon="el-icon-plus" circle @click="copy" />
      </el-form-item>
      <div style="max-height: 900px; overflow-y: auto;width: 600px;">
        <div v-for="(item,i) in query.content" :key="i">
          <el-card class="box-card" :body-style="{ padding: '10px' }" style="width: 500px;margin-bottom: 20px;">
            <el-form-item label="图片" class="formitemupload">
              <el-button v-if="!item.img" type="success" icon="el-icon-upload" size="small" @click="handleUploadClick">上传
                <input v-if="!item.img" ref="fileinput" style="display:none;" type="file" multiple accept="image/gif,image/jpg,image/jpeg,image/png" @change="uploadPictures($event,i)">
              </el-button>
              <div style="display: flex;">
                <img v-if="item.img" :src="item.img" class="avatar">
                <i v-if="item.img" style="margin-left: 30px;" class="el-icon-delete" @click="deleteitemimg(i)" />
              </div>
            </el-form-item>
            <el-form-item label="淘宝口令">
              <el-input v-model="item.copy_code" style="width: 200px;" placeholder="请输入淘宝口令" />
            </el-form-item>
            <el-form-item label="描述">
              <el-input v-model="item.desc" style="width: 200px;" placeholder="请输入内容" />
            </el-form-item>
            <el-button v-show="query.content.length!=1" style="float: right;margin-bottom: 10px;" type="danger" icon="el-icon-delete" circle @click="deleteitem(i)" />
          </el-card>
        </div>
      </div>

    </el-form>
    <div style=" display: flex;justify-content: end;">
      <el-button type="primary" @click="submit">确定</el-button>
    </div>
  </div>
</template>

<script>
import { advertiserList } from '@/api/customer.js'
import { wechat, user_action_sets } from '@/api/taobaoLink.js'
import { qiniuToken } from '@/api/qiniuToken'
import * as qiniu from 'qiniu-js'
import getNowDate from '@/utils/mixins/convertToHump.js'

export default {
  mixins: [getNowDate],
  props: {
    // eslint-disable-next-line vue/require-prop-types
    currentItem: {
      default() {
        return {
        }
      }
    },
    url: {
      type: String,
      default: ''
    }

  },
  data() {
    return {
      imageUrl: '',
      query: {
        id: null,
        app_id: null,
        account_id: null,
        action_id: null,
        // title: null,
        title: '',
        link_code: null,
        content: [
          {
            copy_code: null,
            desc: null,
            img: null
          }
        ]
      },
      queryname: {
        app_name: this.currentItem.wechat_name,
        account_name: null,
        action_name: null
      },
      dialogVisible: false,
      fileList2: [],
      token: '',
      temporary: '',
      // temporary: []
      loaditem: false,
      isUploading: false
    }
  },
  async created() {
    // console.log(this.url, '000', this.currentItem, this.currentItem.id)
    this.getQiniuToken()
    if (this.currentItem.id === undefined) {
      this.loaditem = true
      return
    }
    this.query = {
      id: this.currentItem.id,
      app_id: this.currentItem.app_id,
      account_id: this.currentItem.account_id,
      action_id: this.currentItem.action_id,
      title: this.currentItem.title,
      link_code: this.currentItem.link_code,
      content: []
    }
    const data = await advertiserList({ account_id: this.currentItem.account_id })
    const res = await user_action_sets({ account_id: this.currentItem.account_id })
    this.queryname.account_name = data.data.list[0].account_name
    res.data.list.map(v => {
      if (v.user_action_set_id.toString() === this.currentItem.action_id) {
        this.queryname.action_name = v.name
      }
    })
    // console.log('this.currentItem.content:', this.currentItem.content)
    this.currentItem.content.map((item, i) => {
      // console.log('this.query.content:', this.query.content)
      this.$nextTick(() => {
        this.query.content.push(
          {
            copy_code: item.copy_code,
            desc: item.desc,
            img: this.url + item.img
          }
        )
      })
    })
    this.loaditem = true
  },
  mounted() {

  },
  methods: {
    handleUploadClick() {
      if (!this.isUploading) {
        this.isUploading = true
        this.$nextTick(() => {
          this.$refs.fileinput[0].click()
        })
      } else {
        this.isUploading = false
      }
    },
    submit() {
      console.log('this.query:', this.query)
      this.$emit('determine', this.query)
    },
    async uploadPictures(e, s) {
      this.isUploading = false
      for (let i = 0; i < e.target.files.length; i++) {
        const fileIfon = e.target.files[i]
        const img = new Image()
        const temporary = e.target.files.length > 1 ? '多张' : window.URL.createObjectURL(fileIfon)
        temporary !== '多张' && (img.src = temporary)
        this.temporary = temporary
        const options = {
          quality: 0.62,
          noCompressIfLarger: false,
          maxWidth: 1000,
          maxHeight: 1000
        }
        const ftype = fileIfon.name.substr(fileIfon.name.lastIndexOf('.')) // 截取文件格式
        const extension = ftype === '.jpg'
        const extension2 = ftype === '.png'
        const extension3 = ftype === '.jpeg'
        const extension4 = ftype === '.gif'
        // eslint-disable-next-line eqeqeq
        if (!extension && !extension2 && !extension3 && !extension4) {
          this.$message({
            message: '请上传正确的上传格式(jpg, png, jpeg, gif)',
            type: 'error'
          })
          return
        }

        if (ftype !== '.gif') {
          qiniu.compressImage(fileIfon, options).then(data => {
            const observable = qiniu.upload(data.dist, `user/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`, this.token, {
              fname: fileIfon.name // 文件名
            }, {
              useCdnDomain: true // cdn域名加速
            })
            observable.subscribe({
              next() { },
              error(err) {
                console.log(err)
              },
              complete: (data) => {
                // this.query.content[s].key = this.temporary
                this.query.content[s].img = this.url + data.key
                // console.log('data:', data, this.query)
              }

            })
          })
        } else {
          console.log(222222)
          const observable = qiniu.upload(fileIfon, `user/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`, this.token, {
            fname: fileIfon.name // 文件名
          }, {
            useCdnDomain: true // cdn域名加速
          })
          observable.subscribe({
            next() { },
            error(err) {
              console.log(err)
            },
            complete: (data) => {
              console.log('data:', data)
              this.query.content[s].img = this.temporary
            }

          })
        }
        // const observable = qiniu.upload(fileIfon, `user/${Math.random().toString(36).slice(-6) + '--' + fileIfon.name}`, this.token, {
      }
    },
    getQiniuToken() {
      qiniuToken().then(res => {
        this.token = res.data.uptoken
      })
    },
    copy() {
      console.log(1)
      this.query.content.push({
        copy_code: null,
        desc: null,
        img: null
      })
      console.log('this.query:', this.query)
    },
    deleteitem(index) {
      this.query.content.splice(index, 1)
    },
    deleteitemimg(i) {
      this.query.content[i].img = null
    },
    // 搜索公众号
    async querySearchAsync(name, cb) {
      const data = await wechat({ name: name || undefined })
      cb(data.data.map((item) => { return { ...item, value: item.account_name, address: item.app_id } }))
    },
    async querySearchAsyncad(name, cb) {
      const data = await advertiserList({ account_name: name || undefined })
      cb(data.data.list.map((item) => { return { ...item, value: item.account_id + '-' + item.account_name, address: item.account_id } }))
    },
    async querySearchAsyncuser(name, cb) {
      const data = await user_action_sets({ account_id: this.query.account_id || undefined })
      cb(data.data.list.map((item) => { return { ...item, value: item.user_action_set_id + '-' + item.name, address: item.user_action_set_id } }))
    },
    // 选中公众号
    handleSelect(item) {
      console.log('item:', item)
      this.query.app_id = item.app_id
      this.queryname.app_name = item.account_name
    },
    handleSelectad(item) {
      console.log('item:', item)
      this.query.account_id = item.account_id
      this.queryname.account_name = item.account_name
    },
    handleSelectuser(item) {
      console.log('item:', item)
      this.query.action_id = item.user_action_set_id
      this.queryname.action_name = item.name
    },
    generateRandomString() {
      const characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
      let randomString = ''
      for (let i = 0; i < 6; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length)
        randomString += characters[randomIndex]
      }
      this.query.link_code = randomString
    }
  }
}
</script>

<style scoped>
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
  /* .formitemupload {
  position: relative;
  margin-bottom: 20px;
  height: 50px;
}
 ::v-deep .el-upload--picture-card {
    transform: scale(0.35);
    position: absolute;
    top: -40px;
    left: -35px;
    } */
    .el-form-item {
    margin-bottom: 16px;
   }
   .box{
  height: 10px;
   }
</style>
